import { useState } from 'react';

import { StayInputOverrides } from './otaParity/types';
import { useOtaRateShopOrchestration } from './useOtaRateShopOrchestration';

// Combines stay inputs and the in-flight/completed rate-shop job into one Scrape session slice.
export function useScrapeSession() {
  const [stayInputs, setStayInputs] = useState<StayInputOverrides | null>(null);
  const orchestration = useOtaRateShopOrchestration();

  return { stayInputs, setStayInputs, ...orchestration };
}
